import React from 'react';
import workspaceQuery from '../../../graphql/queries/company/CommonImportWorkspaceQuery.graphql';
import listQuery from '../../../graphql/queries/company/CommonImportListQuery.graphql';
import instanceQuery from '../../../graphql/queries/company/CommonImportQuery.graphql';
import defaultQuery from '../../../graphql/queries/company/CommonImportDefault.graphql';
import mutationQuery from '../../../graphql/mutations/company/CommonImportMutation.graphql';
import temporaryMutationQuery from '../../../graphql/mutations/company/CommonImportTemporaryMutation.graphql';
import fragment from '../../../graphql/fragments/company/CommonImportFragment.graphql';
import { ALLOW_ADD, ALLOW_VIEW } from '../../../utils/OperationPermissions';
import fieldMetaData from '../../schema/fieldMetaData';
import { Direction } from '../../schema/p4types';
import { IDropdownOptionRenderer } from '../../../@types/entityTypes';

const CommonImportOptionRenderer: IDropdownOptionRenderer = ({ option }) => {
  const entity = fieldMetaData.Entity.enumValues.find((ev) => option.entity === ev.value);
  const createdAt = new Date(option.createdAt);
  return (
    <span>
      {entity?.label} ({createdAt.toLocaleString()})
    </span>
  );
};

const CommonImport = {
  type: 'Import',
  title: 'Imports',
  formTitle: 'Import',
  formUrl: '/Company/Import/Details/',
  workspaceUrl: '/Company/Import/Workspace/',
  instance: instanceQuery,
  workspace: workspaceQuery,
  default: defaultQuery,
  update: mutationQuery,
  temporarySave: temporaryMutationQuery,
  dropdown: {
    query: listQuery,
    valueKey: 'id',
    labelKey: 'createdAt',
    optionRenderer: CommonImportOptionRenderer,
    valueRenderer: CommonImportOptionRenderer,
    customVariables: () => {
      return {
        orderBy: 'createdAt',
        orderDirection: Direction.Desc,
      };
    },
  },
  fragment,
  screenReference: 'COMMON_IMPORT',
  operations: ALLOW_ADD | ALLOW_VIEW,
};

export default CommonImport;
